import React, {type ButtonHTMLAttributes, type ReactNode} from 'react'
import classNames from "classnames";

type ButtonSize = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

type PrimaryButtonProps = {
  size?: ButtonSize
  onClick?: () => void
  children: ReactNode
} & ButtonHTMLAttributes<HTMLButtonElement>

const paddingMap: Record<ButtonSize, string> = {
  xs: 'px-2 py-1',
  sm: 'px-2 py-1',
  md: 'px-2.5 py-1.5',
  lg: 'px-3 py-2',
  xl: 'px-3.5 py-2.5',
}

const textSizeMap: Record<ButtonSize, string> = {
  xs: 'text-xs',
  sm: 'text-sm',
  md: 'text-sm',
  lg: 'text-sm',
  xl: 'text-sm',
}

const Button: React.FC<PrimaryButtonProps> = ({
                                                size = 'md',
                                                children,
                                                className,
                                                ...props
                                              }) => {
  return (
    <button
      className={classNames(className, `rounded-md bg-emerald-600 font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600 ${paddingMap[size]} ${textSizeMap[size]}`)}
      {...props}
    >
      {children}
    </button>
  )
}

export default Button
